<template>
  <div id="balanceSheet">
    <div class="public-content">
      <div class="balanceSheet_top clearfix">
        <el-form :inline="true" class="fl balanceSheetForm">
          <el-form-item label="业务活动表">
           <el-select v-model="select.reportVal" size="mini" class="report-select" style='width: 80px;'>
							<el-option
								v-for="item in options.reportOps"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
          </el-form-item>
          	<el-form-item>
						<template v-if="!isShowQuarter">
							<accounting-period @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
						</template>
						<template v-else>
							<el-date-picker
								v-model="date.nowYearPeriods"
								 style='width: 140px;'
								type="year"
								size="mini"
								class="year-editor"
								placeholder="选择年"
								:clearable="false"
								:picker-options="pickerBeginDateBefore"
								@change="handleYearChange">
							</el-date-picker>
							<el-select v-model="select.quarterVal" size="mini" class="quarter-select" style='width: 120px;'>
								<el-option
									v-for="item in options.quarterOps"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</template>
					</el-form-item>
        </el-form>
        <el-form :inline="true" class="fl balanceSheetForm">
          <el-form-item>
            <el-button size="mini" class="balanceSheet_elButtom minButton" @click="buttonSeach">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="fr">
          <template v-for="(item,index) in options.permiss">
            <print-operation
              v-if="item.permission == 'business:activities:print'"
              :key="index"
              :formData="printForm"
              :showContinuit="false"
            ></print-operation>
            <el-button
              v-if="item.permission == 'business:activities:export'"
              :key="index"
              size="small"
              @click="handleDownload"
            >导出</el-button>
          </template>
        </div>
        <!-- 数据列表  -->
        <!-- 公共table 样式 -->
        <div class="table-item-public">
          <el-table
            v-loading="loading"
            :element-loading-text="loadingText"
            border
            size="small"
            style="width:100%"
            :data="tableData"
            @cell-click="refreshTable"
          >
            <el-table-column label="项目" align="center" width="320">
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  v-if="scope.row.style != 3"
                  @click="oepnDialogs(scope.row)"
                >{{scope.row.name}}</a>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="行次" prop="rowNumber" align="center" width="80"></el-table-column>
            <el-table-column label="本月数" align="center">
              <el-table-column label="非限定性" align="center">
                <template slot-scope="scope">
                  <div class="column_row" @dblclick="column(scope.row)">
                    <span v-show="!scope.row.showInput">{{formatter(scope.row.unqualified)}}</span>
                    <el-input
                      @change="ifChangeColumn"
                      maxlength="9"
                      v-if="scope.row.showInput"
                      v-model.number="scope.row.unqualified"
                      size="small"
                      @blur="savatemplate(scope.row)"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="限定性" align="center">
                <template slot-scope="scope">
                  <div class="column_row" @dblclick="column(scope.row)">
                    <span v-show="!scope.row.showInput">{{formatter(scope.row.qualified)}}</span>
                    <el-input
                      maxlength="9"
                      v-if="scope.row.showInput"
                      v-model.number="scope.row.qualified"
                      size="small"
                      @blur="savatemplate(scope.row)"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合计" align="center">
                <template slot-scope="scope">
                  <span>{{formatter(scope.row.total)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="本年累计数" align="center">
              <el-table-column label="非限定性" align="center">
                <template slot-scope="scope">
                  <div class="column_row" @dblclick="column(scope.row)">
                    <span v-show="!scope.row.showInput">{{formatter(scope.row.yearUnqualified)}}</span>
                    <el-input
                      maxlength="9"
                      v-if="scope.row.showInput"
                      v-model.number="scope.row.yearUnqualified"
                      size="small"
                      @blur="savatemplate(scope.row)"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="限定性" align="center">
                <template slot-scope="scope">
                  <div class="column_row" @dblclick="column(scope.row)">
                    <span v-show="!scope.row.showInput">{{formatter(scope.row.yearQualified)}}</span>
                    <el-input
                      maxlength="9"
                      v-if="scope.row.showInput"
                      v-model.number="scope.row.yearQualified"
                      size="small"
                      @blur="savatemplate(scope.row)"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合计" align="center">
                <template slot-scope="scope">
                  <span>{{formatter(scope.row.yearTotal)}}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <super-active-dialog
      :dialogVisible.sync="isShowReport"
      :data="reportDialogData"
      :showRegulation="true"
      @onShowDialog="showDialog"
      @onRefresh="refresh"
    ></super-active-dialog>
  </div>
</template>
<script>
import printOperation from "@/components/print";
import { currencys } from "@/assets/utils/currencyFormat";
import accountingPeriod from "@/components/dialog/accountingPeriod";
import superActiveDialog from "@/components/dialog/superActiveDialog";
export default {
  components: {
    printOperation,
    accountingPeriod,
    superActiveDialog
  },
  data() {
    return {
      ifChange: false,
      loadingText: "请稍后...",

      isShowReport: false, // 是否显示弹窗
      reportDialogData: {
        // 弹窗参数
        reportId: "",
        quarter: '',
        yearPeriods: "",
        style: ""
      },
      arrBtn: ["business:activities:print", "business:activities:export"],
      loading: false,
      tableData: [],
	  firstGet: true, 
      printForm: {
        data: {
          reclassify: false,
          yearPeriods: ""
        },
        url: "/createPDF/businessActivity",
        continuityUrl: "/createPDF/businessActivity"
      },
      // form: {
      //   reclassify: false,
      //   yearPeriods: ""
      // },
      select: {			// 选择框数据
					reportVal: '1',
					quarterVal: '_1'
				},
      form: {			// 筛选条件
        reclassify: false,
        yearPeriods: '',
        quarter: ''
      },
      pickerBeginDateBefore: {
					disabledDate: (time) => {
						let beginStartDateVal = this.date.start;
						let beginEndDateVal = this.date.end;

						if (beginEndDateVal && beginEndDateVal) {
							return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
						}
					}
				},

      date: {			// 日期控件参数
					start: '',
					end: '',
					nowYearPeriods: ''
				},
      options: {			// 选择框option数据
					reportOps: [{
						label: '月报',
						value: '1',
					},{
						label: '季报',
						value: '2',
					}],
					quarterOps: [{
						label: '第一季度',
						value: '_1',
					},{
						label: '第二季度',
						value: '_2',
					},{
						label: '第三季度',
						value: '_3',
					},{
						label: '第四季度',
						value: '_4',
					}],
				}
    };
  },
  created() {
    //this.buttonSeach();
    this.findPermissionMenu();
  },
  computed: {
    
    isShowQuarter () {      
				this.form = Object.assign({}, this.form, {
					quarter: this.select.reportVal != '1' ? this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyy') + this.select.quarterVal : '',
					yearPeriods: this.select.reportVal == '1' ? (this.form.yearPeriods ? this.form.yearPeriods : this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyyMM')) : ''
				})
           
				this.$set(this.printForm, 'data', {
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				})

				return this.select.reportVal === '1' ? false : true;
			}
  },
  activated() {
    this.buttonSeach();
  },
  methods: {
    //刷新表格
    refreshTable() {
      if (this.ifChange) {
        this.buttonSeach();
      }
    },
    ifChangeColumn() {
      const _ = this;
      _.ifChange = true;
    },
    //保存 行数据
    savatemplate(row) {
      const _ = this;
      row.total =
        parseFloat(row.unqualified ? row.unqualified : 0) +
        parseFloat(row.qualified ? row.qualified : 0);
      row.yearTotal =
        parseFloat(row.yearUnqualified ? row.yearUnqualified : 0) +
        parseFloat(row.yearQualified ? row.yearQualified : 0);

      //_.loading = true;
      _.loadingText = "保存中...";
      _.$http
        .post("reportform/addBusinessActivities", {
          yearPeriods: _.form.yearPeriods,
          qualified: row.qualified,
          unqualified: row.unqualified,
          yearQualified: row.yearQualified,
          yearUnqualified: row.yearUnqualified,
          total: row.total,
          yearTotal: row.yearTotal,
          templateId: row.templateId
        })
        .then(res => {
          _.loading = false;
          if (res && res.data.code == "1") {
            //_.$message.success(res.data.msg);
          }
        })
        .catch(e => {
          _.loading = false;
        });
    },
    //点击事件 table
    column(cols) {
      const _ = this;
      if (cols.formula == "2") {
        cols.showInput = true;
      }
    },
    //格式化数据
    formatter(cellValue) {
      if (cellValue == "" || cellValue == null) {
        return "";
      } else {
        return currencys(cellValue);
      }
    },
    //查询权限
    findPermissionMenu() {
      const _ = this;
      let params = {
        permissions: _.arrBtn.join(",")
      };
      _.$http
        .post("sys/menu/findPermissionMenu", params)
        .then(res => {
          if (res && res.data.code == "1") {
            this.options.permiss = res.data.data;
          }
        })
        .catch(e => {});
    },
    //打开弹出层
    oepnDialogs(row) {
      const _ = this;
      _.reportDialogData = Object.assign({}, _.reportDialogData, {
        reportId: row.id,
        yearPeriods: this.form.yearPeriods,
        quarter: this.form.quarter,
        style: row.style
      });
      _.isShowReport = true;
    },
    //获取业务活动表
    buttonSeach() {     
      const _ = this;
      _.ifChange = false;
      _.loading = true;
      _.loadingText = "请稍等...";
      _.$http
        .post("reportform/findBusinessActivities", this.form)
        .then(res => {
          _.loading = false;
          if (res && res.data.code == "1") {
            let list = res.data.data;
            for (let i = 0; i < list.length; i++) {
              list[i].showInput = false;
            }
            _.tableData = list;
          }
        })
        .catch(res => {
          _.loading = false;
        });
    },
    // 接收会计期间数据
    
    defaultTime(data) {      
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				this.date = Object.assign({}, this.date, {
					start: data.defaultStartDate,
					end: data.defaultEndDate,
					nowYearPeriods: data.yearPeriodsStart
				})	
        if(this.firstGet) {				
					this.firstGet = false;
				}
        
			},  
    
    // 导出
    handleDownload() {
      const params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        yearPeriods: this.form.yearPeriods,
        reclassify: this.form.reclassify,
        quarter:this.form.quarter
      };
      const router = this.$router.resolve({
        path: "/export/businessActivity",
        query: params
      });
      window.open(this.$rootUrl + router.href, "_blank");
    },
    // 弹框显示
    showDialog(val) {
      this.isShowReport = val;
    },
    // 重载数据
    refresh(val) {
      val && this.buttonSeach();
    }
  },
  mounted() {}
};
</script>
<style lang='less'>
#balanceSheet {
  .balanceSheet_top {
    .balanceSheetForm {
      .balanceSheet_elButtom {
        margin: 0 20px;
      }
    }
  }
  .column_row {
    min-height: 28px;
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/reportForm/businessActivities.vue